import { JobStats } from '../../../../interfaces/job';
import styles from './JobStatsTable.module.scss';
import { JobStatCard } from '../JobStatCard/JobStatCard';
import { jobStatsTableDataIds } from '../../data-ids';
import Duration from '../../../../../shared/components/Duration/Duration';
import { Tooltip } from '../../../../../tooltip/Tooltip';
import { numFormatter } from '../../../../../shared/utils/number/formatter';
import { Calendar } from '../../../../../shared/components/Calendar/Calendar';
import { NumFormattingType } from '../../../../../shared/utils/number/interface';
import { JOB_STATS_NAMES } from './strings';
import { STAT_ICON_MAP } from '../../../../constants/job-stat';
import { LatencyWrapper } from '../../../LatencyWrapper/LatencyWrapper';

export interface JobStatsTableProps {
  stats: JobStats;
  isLoadOnly: boolean;
  latencyNotApplicable: boolean;
}

export function JobStatsTable({ stats, isLoadOnly, latencyNotApplicable }: JobStatsTableProps) {
  return (
    <div className={styles.jobStatsTable}>
      <div className={styles.jobStatsRow}>
        <JobStatCard
          className='mb-4'
          statTitleClassName='w-40'
          statValueClassName='w-60'
          statIcon={STAT_ICON_MAP.startedAt}
          statName={JOB_STATS_NAMES.startedAt}
          dataId={jobStatsTableDataIds.startedAt}
        >
          <Calendar value={stats.startedAt} options={{ hideZeroTimestamp: true }} />
        </JobStatCard>

        <JobStatCard
          className='mb-4'
          statTitleClassName='w-40'
          statValueClassName='w-60'
          statIcon={STAT_ICON_MAP.duration}
          statName={JOB_STATS_NAMES.duration}
          dataId={jobStatsTableDataIds.duration}
        >
          <Duration duration={stats.duration} options={{ useAbbr: true, separateUnits: true }} />
        </JobStatCard>

        <JobStatCard
          statTitleClassName='w-40'
          statValueClassName='w-60'
          statIcon={STAT_ICON_MAP.latency}
          statName={JOB_STATS_NAMES.latency}
          dataId={jobStatsTableDataIds.latency}
        >
          <LatencyWrapper
            latency={stats.latency}
            showIcon={false}
            latencyNotApplicable={latencyNotApplicable}
          />
        </JobStatCard>
      </div>

      <div className={styles.jobStatsRow}>
        <JobStatCard
          className='mb-4'
          statIcon={STAT_ICON_MAP.objectsSuccess}
          statName={JOB_STATS_NAMES.objectsSuccess}
          dataId={jobStatsTableDataIds.objectsSuccess}
        >
          <Tooltip title={stats.objectsSuccess} dataId={jobStatsTableDataIds.objectsQueued}>
            <span>{numFormatter(stats.objectsSuccess, NumFormattingType.SHORT, false)}</span>
          </Tooltip>
        </JobStatCard>

        <JobStatCard
          className='mb-4'
          statIcon={STAT_ICON_MAP.objectsQueued}
          statName={JOB_STATS_NAMES.objectsQueued}
          dataId={jobStatsTableDataIds.objectsQueued}
        >
          <Tooltip title={stats.objectsQueued} dataId={jobStatsTableDataIds.objectsQueued}>
            <span>{numFormatter(stats.objectsQueued, NumFormattingType.SHORT, false)}</span>
          </Tooltip>
        </JobStatCard>

        <JobStatCard
          statIcon={STAT_ICON_MAP.objectsFailed}
          statName={JOB_STATS_NAMES.objectsFailed}
          dataId={jobStatsTableDataIds.objectsFailed}
        >
          <Tooltip title={stats.objectsFailed} dataId={jobStatsTableDataIds.objectsFailed}>
            <span>{numFormatter(stats.objectsFailed, NumFormattingType.SHORT, false)}</span>
          </Tooltip>
        </JobStatCard>
      </div>

      <div className={styles.jobStatsRow}>
        {!isLoadOnly && (
          <JobStatCard
            className='mb-4'
            statIcon={STAT_ICON_MAP.eventsIngested}
            statName={JOB_STATS_NAMES.eventsIngested}
            dataId={jobStatsTableDataIds.eventsIngested}
          >
            <Tooltip title={stats.eventsIngested} dataId={jobStatsTableDataIds.eventsIngested}>
              <span>{numFormatter(stats.eventsIngested, NumFormattingType.SHORT, false)}</span>
            </Tooltip>
          </JobStatCard>
        )}

        <JobStatCard
          dataId={jobStatsTableDataIds.eventsLoaded}
          className='mb-4'
          statIcon={STAT_ICON_MAP.eventsLoaded}
          statName={JOB_STATS_NAMES.eventsLoaded}
        >
          <Tooltip title={stats.eventsLoaded} dataId={jobStatsTableDataIds.eventsLoaded}>
            <span>{numFormatter(stats.eventsLoaded, NumFormattingType.SHORT, false)}</span>
          </Tooltip>
        </JobStatCard>

        <JobStatCard
          dataId={jobStatsTableDataIds.eventsFailed}
          statIcon={STAT_ICON_MAP.eventsFailed}
          statName={JOB_STATS_NAMES.eventsFailed}
        >
          <Tooltip title={stats.eventsFailed} dataId={jobStatsTableDataIds.eventsFailed}>
            <span>{numFormatter(stats.eventsFailed, NumFormattingType.SHORT, false)}</span>
          </Tooltip>
        </JobStatCard>
      </div>
    </div>
  );
}
